// This function returns the coordinate
// conversion string in DD to DMS.
export function ddToDms(lat, lng, addSpace = false, leadingZero = false, short = false) {
    let latResult, lngResult, dmsResult;
    lat = parseFloat(lat);
    lng = parseFloat(lng);

    latResult = (lat >= 0) ? 'N' : 'S';
    if (addSpace) latResult += ' ';

    // Call to getDms(lat) function for the coordinates of Latitude in DMS.
    // The result is stored in latResult variable.
    latResult += getDms(lat, leadingZero, short);

    lngResult = (lng >= 0) ? 'E' : 'W';
    if (addSpace) lngResult += ' ';

    // Call to getDms(lng) function for the coordinates of Longitude in DMS.
    // The result is stored in lngResult variable.
    lngResult += getDms(lng, leadingZero, short);

    // Return the resultant string
    return {'lat': latResult, 'lng': lngResult};
}

export function getDms(val, leadingZero = false, short = false) {
    let valDeg, valMin, valSec, result;

    val = Math.abs(val);

    valDeg = Math.floor(val);
    result = valDeg + "º";

    if (leadingZero)
        result = ('0' + valDeg).slice(-2) + "º";

    valMin = Math.floor((val - valDeg) * 60);
    result += ('0' + Math.round(valMin)).slice(-2) + "'";

    if (!short) {
        valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
        result += ('0' + Math.round(valSec)).slice(-2) + '"';
    }

    return result;
}

export function roundNumber(num, scale) {
    if (!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale) + "e-" + scale);
    } else {
        const arr = ("" + num).split("e");
        let sig = "";
        if (+arr[1] + scale > 0) {
            sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
}
